(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9261,1674],{

/***/ 905574:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer-page",
      function () {
        return __webpack_require__(208386);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 208386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331399);
/* harmony import */ var _containers_OfferPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(796181);




var _OfferPage = function(props) {
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        store: props === null || props === void 0 ? void 0 : props.storeInfo,
        storeInfo: props === null || props === void 0 ? void 0 : props.storeInfo,
        title: props === null || props === void 0 ? void 0 : props.storeInfo.store_name,
        Icon: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
        metaDescription: "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGImage: props === null || props === void 0 ? void 0 : (ref2 = props.storeInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.store_info) === null || ref3 === void 0 ? void 0 : ref3.logo_image,
        isCustomDomain: props.isCustomDomain,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_OfferPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            storeInfo: props.storeInfo
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (_OfferPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,5843,6379,7856,9228,4429,6246,1033,1399,3978,2682,526,8557,1788,1868,9996,5684,6711,9774,2888,179], function() { return __webpack_exec__(905574); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);